import request from '../utils/request';

export interface PhoneBlacklist {
  id: number;
  phone: string;
  remark?: string;
  created_by: number;
  creator_name?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

export interface PhoneBlacklistCreate {
  phone: string;
  remark?: string;
}

export interface PhoneBlacklistUpdate {
  remark?: string;
}

export interface BlacklistCheckResponse {
  is_blacklisted: boolean;
  remark?: string;
  created_at?: string;
  creator_name?: string;
}

// 获取黑名单列表
export const getPhoneBlacklist = (params?: {
  skip?: number;
  limit?: number;
  keyword?: string;
}): Promise<PhoneBlacklist[]> => {
  return request.get('/phone-blacklist/', { params });
};

// 添加到黑名单
export const addPhoneBlacklist = (data: PhoneBlacklistCreate): Promise<PhoneBlacklist> => {
  return request.post('/phone-blacklist/', data);
};

// 检查手机号是否在黑名单中
export const checkPhoneBlacklist = (phone: string): Promise<BlacklistCheckResponse> => {
  return request.get(`/phone-blacklist/check/${phone}`);
};

// 更新黑名单备注
export const updatePhoneBlacklist = (id: number, data: PhoneBlacklistUpdate): Promise<PhoneBlacklist> => {
  return request.put(`/phone-blacklist/${id}`, data);
};

// 解除拉黑（软删除）
export const deletePhoneBlacklist = (id: number): Promise<{ message: string }> => {
  return request.delete(`/phone-blacklist/${id}`);
};
